/* eslint-disable vue/valid-v-slot */
import { Teaching, Teacher, Class, TeacherCat, SubjectGroup, TeacherDoc } from '@/plugins/api'
import { get } from 'lodash'

export default {
  namespaced: true,
  state: {
    teachings: [],
    teaching: {},
    teachers: [],
    class: [],
    schoolYearId: ''
  },
  actions: {
    async fetchTeachings({ commit }, options) {
      const teachings = await Teaching.fetch({ ...options, _limit: -1 })
      return teachings.filter(x => x.teacher && get(x, 'teacher.status') === 'active')
    },

    async fetchTeaching({ commit }, teachingId) {
      const teaching = await Teaching.fetchOne(teachingId)
      commit('setTeaching', teaching)
    },
    async fetchTeachers({ commit }, options) {
      const teachers = await Teacher.fetch({ ...options, _limit: -1 })
      return teachers
    },
    async fetchClasses({ commit }, options) {
      const classes = await Class.fetch({ ...options, _limit: -1 })
      return classes
    },
    async fetchTeacherCat({ commit }, options) {
      const categories = await TeacherCat.fetch({ ...options, _limit: -1 })
      return categories
    },
    async fetchSubjectGroups({ commit }, options) {
      const subjects = await SubjectGroup.fetch({ ...options, _limit: -1 })
      return subjects
    },
    async fetchTeacherDocs({ commit }, options) {
      const documents = await TeacherDoc.fetch({
        ...options,
        _sort: 'createdAt:desc'
      })
      return documents
    },
    async createTeacherDoc({ commit }, data) {
      const document = await TeacherDoc.create(data)
      return document
    },
    async removeTeacherDoc({ commit }, id) {
      const document = await TeacherDoc.remove(id)
      return document
    },
    async updateTeacherDoc({ commit }, { id, data }) {
      const updatedDocument = await TeacherDoc.update(id, data)

      return updatedDocument
    },
    async fetchTeacherDocCount({ commit }, params = {}) {
      const count = await TeacherDoc.count(params)
      return count
    }
  },
  mutations: {
    setTeaching(state, teaching) {
      const teachings = state.teachings.map(t => {
        if (t.id === teaching.id) {
          return teaching
        } else return t
      })
      state.teachings = teachings
    },
    setTeachings(state, teachings) {
      state.teachings = teachings
    },
    setTeachers(state, teachers) {
      state.teachers = teachers
    },
    setClasses(state, classes) {
      state.classes = classes
    },
    setSchoolYearId(state, schoolYearId) {
      state.schoolYearId = schoolYearId
    }
  }
}
